var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import AlertCard from '@/components/alert-card/AlertCard';
import AddChatUser from '@/components/chat/AddChatUser';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { RolesEnum } from '@/items/Roles';
import { File as FileModel } from '@/models/File';
import { Message } from '@/models/Message';
import { Model } from '@/models/Model';
import { Participant } from '@/models/Participant';
import { User } from '@/models/User';
import { identifyHostname } from '@/support/Client';
import ErrorHandler from '@/support/ErrorHandler';
import { replaceUrlsWithAnchorTags } from '@/support/String';
import { Token } from '@/support/Token';
import Echo from 'laravel-echo';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let Chat = class Chat extends Vue {
    constructor() {
        super(...arguments);
        this.author = new User();
        this.isConnected = false;
        this.isDisplayingDialog = false;
        this.isDisplayingDeleteDialog = false;
        this.selectedMessage = null;
        this.selectedParticipant = null;
        this.isAddingUser = false;
        this.urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g;
        this.hostRegex = /^((http|https|ftp):\/\/)/;
        this.messagesLoaded = [];
        this.messagesFound = [];
        this.input = '';
        this.showAttachmentList = false;
        this.showMemberList = true;
        this.isFavorite = false;
        this.fileName = '';
        this.fileInput = null;
        this.message = new Message({ value: '' });
        this.file = undefined;
        this.hasFile = false;
        this.files = [];
        this.inputType = 'single';
        this.attachments = [];
        this.participants = null;
        this.search = '';
        this.isLoading = true;
    }
    get roomId() {
        return this.room.substring(13);
    }
    get avatar() {
        return this.author !== undefined && this.author.avatar !== undefined
            ? this.author.avatar
            : 'https://via.placeholder.com/180x180';
    }
    get messages() {
        return this.search.length > 0 ? this.messagesFound : this.messagesLoaded;
    }
    get hasMessages() {
        return this.messages.length > 0;
    }
    get dialogOptions() {
        const message = this.selectedMessage;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, {
                item: this.$t('dialogOptions.item.message'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!message) {
                            return;
                        }
                        message
                            .delete()
                            .then((response) => {
                            const edittedMessage = this.messagesLoaded.find((currentMessage) => {
                                return currentMessage.id === message.id;
                            });
                            if (edittedMessage) {
                                edittedMessage.text = '';
                                edittedMessage.deleted_at = DateTime.local().toFormat('yyyy-LL-dd HH:mm:ss');
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedMessage = null;
                    },
                },
            },
        };
    }
    get deleteDialogOptions() {
        const participant = this.selectedParticipant;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, {
                item: this.$t('dialogOptions.item.user'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!participant || !participant.user) {
                            return;
                        }
                        new Participant()
                            .setDeleteEndpoint(participant.user, this.roomId)
                            .delete()
                            .then((response) => {
                            if (!this.participants) {
                                return;
                            }
                            this.participants = this.participants.filter((currentParicipant) => {
                                return currentParicipant.user.id !== participant.user.id;
                            });
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedMessage = null;
                    },
                },
            },
        };
    }
    mounted() {
        this.author = this.$store.state.Auth;
        // this.getMessages();
        this.getParticipants();
        this.getFiles();
        this.sanitizeRoom(this.room);
        if (this.realtime) {
            this.echo = this.newEchoInstance();
            this.listen(this.room);
        }
    }
    getFiles() {
        new FileModel()
            .filter('room', this.roomId)
            .all()
            .then((files) => {
            this.files = files;
        });
    }
    getMessages() {
        this.isLoading = true;
        const isSearch = this.search.length > 0;
        const filters = {
            room: this.roomId,
        };
        if (isSearch) {
            filters.search = this.search;
        }
        new Message()
            .include(['user', 'file'])
            .filter(filters)
            .limit(isSearch ? 50 : 25)
            .all()
            .then((messages) => {
            if (isSearch) {
                this.messagesFound = messages.reverse();
            }
            else {
                this.messagesLoaded = messages.reverse();
            }
            setTimeout(() => {
                this.scrollToBottom();
            }, 1);
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    scrollToBottom() {
        const container = document.getElementById('chatContainer');
        if (container !== null) {
            container.scrollTop = container.scrollHeight;
        }
    }
    inputTypeChanged(inputType) {
        const chatInput = document.getElementById('chatInput');
        chatInput && chatInput.focus();
    }
    showAttachments() {
        this.showAttachmentList = !this.showAttachmentList;
    }
    showMembers() {
        this.showMemberList = !this.showMemberList;
    }
    favoriteChat() {
        this.isFavorite = !this.isFavorite;
    }
    avatarChanged(event) {
        //
    }
    searchChanged(search, oldSearch) {
        if (typeof search !== 'string' || search.length <= 0) {
            return;
        }
        this.$debounce('getMessages', search);
    }
    inputChanged(event) {
        this.fileInput = event.target;
        const files = this.fileInput.files;
        if (files === null || !files.length) {
            return;
        }
        this.file = files[0];
        this.message.file = files[0];
        this.fileName = files[0].name;
        this.hasFile = true;
    }
    deleteMessage(message) {
        if (!message.isAuthor) {
            return;
        }
        this.selectedMessage = message;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    deleteParticipant(participant) {
        if (!participant) {
            return;
        }
        this.selectedParticipant = participant;
        this.$store.dispatch('openDialog', this.deleteDialogOptions);
    }
    handleUserAdded(newParticipants) {
        this.$set(this, 'participants', newParticipants);
    }
    getParticipants() {
        new Participant()
            .filter('room', this.roomId)
            .include('roles')
            .limit(100)
            .all()
            .then((participants) => {
            this.participants = participants;
            this.getMessages();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    parseMessageText(message) {
        return replaceUrlsWithAnchorTags(message);
    }
    newEchoInstance() {
        window.Pusher = require('pusher-js');
        window.Pusher.logToConsole = process.env.NODE_ENV !== 'production';
        const pusherKey = process.env.VUE_APP_PUSHER_KEY !== undefined ? process.env.VUE_APP_PUSHER_KEY : '';
        return new Echo({
            broadcaster: 'pusher',
            key: pusherKey,
            authEndpoint: `${identifyHostname()}/v3/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: 'Bearer ' + Token.getAccessToken(),
                },
            },
            namespace: '',
            cluster: process.env.VUE_APP_PUSHER_CLUSTER || 'eu',
            encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED === 'true' ||
                process.env.VUE_APP_PUSHER_ENCRYPTION === '1',
        });
    }
    inputHandler(event) {
        if (event.keyCode === 13 && !event.shiftKey) {
            event.preventDefault();
            this.send();
        }
        if (event.keyCode === 13 && event.shiftKey) {
            event.preventDefault();
            this.inputType = 'multi';
        }
    }
    listen(room) {
        this.echo
            .private(`${this.$room}`)
            .listen('.chat:message.created', (data) => {
            if (this.findById(data.id || '')) {
                return;
            }
            if (data.user.id === this.author.id) {
                return;
            }
            const message = new Model().dataToModel(data, 'Message');
            this.messagesLoaded.push(message);
        })
            .on('pusher:subscription_succeeded', (member) => {
            this.isConnected = true;
        });
    }
    send() {
        if (this.input.length <= 0) {
            return;
        }
        const message = new Message({
            room: this.roomId,
            text: this.input,
            file: this.fileName,
        }).include(['file', 'user']);
        if (this.messageKey) {
            message.key = this.messageKey;
        }
        message.isAuthor = true;
        message.user = this.$store.state.Auth;
        this.input = '';
        this.inputType = 'single';
        if (this.findById(message.id || '')) {
            return;
        }
        const index = this.messagesLoaded.push(message) - 1;
        this.messagesLoaded[index].index = index;
        if (this.file) {
            message.file = this.file;
        }
        message
            .create()
            .then((message) => {
            this.$set(this.messagesLoaded, index, message);
            this.hasFile = false;
            this.file = null;
            if (this.fileInput) {
                this.fileInput.removeAttribute('value');
                this.fileInput.setAttribute('value', '');
            }
            if (message.file && message.file.name) {
                const file = new Model().dataToModel(message.file, 'File');
                this.files.push(file);
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    findById(id) {
        const result = this.messagesLoaded.findIndex((message) => message.id === id);
        const message = result === -1 ? false : this.messagesLoaded[result];
        if (message === undefined) {
            return false;
        }
        return message;
    }
    sanitizeRoom(room) {
        this.$room = room.substring(0, 8) === 'private-' ? room.substring(8) : room;
    }
    messageAdded(messages) {
        this.scrollToBottom();
    }
    canDeleteParticipant(participant) {
        if (!participant || !participant.user || !participant.user.roles) {
            return false;
        }
        if (this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.MANAGER])) {
            return true;
        }
        if (participant.user.id === this.$store.state.Auth.id &&
            !this.$store.state.Auth.hasRole([RolesEnum.STUDENT])) {
            return true;
        }
        const user = new Model().dataToModel(participant.user, 'User');
        if (this.$store.state.Auth.hasRole([RolesEnum.TEACHER]) && user.hasRole([RolesEnum.TEACHER])) {
            return true;
        }
        return false;
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], Chat.prototype, "name", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], Chat.prototype, "room", void 0);
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], Chat.prototype, "messageKey", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Chat.prototype, "realtime", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], Chat.prototype, "userModel", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Chat.prototype, "enableHeader", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Chat.prototype, "enableAttachments", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Chat.prototype, "enableMembers", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Chat.prototype, "enableInput", void 0);
__decorate([
    Prop({ default: '#EFEFEF' }),
    __metadata("design:type", String)
], Chat.prototype, "background", void 0);
__decorate([
    Watch('inputType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Chat.prototype, "inputTypeChanged", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], Chat.prototype, "searchChanged", null);
__decorate([
    Watch('room'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Chat.prototype, "sanitizeRoom", null);
__decorate([
    Watch('messages'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Chat.prototype, "messageAdded", null);
Chat = __decorate([
    Component({
        components: {
            AlertCard,
            LoaderCard,
            AddChatUser,
        },
    })
], Chat);
export default Chat;
